var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useField } from "formik";
import React, { useMemo } from "react";
import { TextInput } from "../../TextInput";
import { Div } from "../../utils";
import { FormikField, useFormikField } from "../fieldHelpers";
export const FormikTextInput = (_a) => {
    var { name, label = null, placeholder, leftIcon = null, type = "text", Component = null, isDisabled = false, withDebounce = true } = _a, props = __rest(_a, ["name", "label", "placeholder", "leftIcon", "type", "Component", "isDisabled", "withDebounce"]);
    const [{ value }, , { setValue, setTouched }] = useField(name);
    const { hasError, errorMsg } = useFormikField(name);
    const InputComponent = Component || TextInput;
    const input = useMemo(() => (React.createElement(FormikField, Object.assign({}, { name }),
        React.createElement(Div, { name: name, tabIndex: 0, focusOutlineNone: true, style: { position: "relative", zIndex: 0 } },
            React.createElement(InputComponent, { label: label, onWheel: (e) => e.target.blur(), isDisabled: isDisabled, type: type, name: name, leftIcon: leftIcon, hasError: hasError, value: value || "", placeholder: placeholder, onBlur: () => setTouched(true), onChange: (v) => {
                    setValue(v);
                } })))), [hasError, errorMsg, value]);
    return React.createElement(Div, Object.assign({}, props), input);
};
//# sourceMappingURL=FormikTextInput.js.map